import React, { Component } from 'react';
import { UIMixin } from "../../../../../dev/mixins/uiMixin";
import { connect } from "react-redux";
import { Select } from '../../../../../dev/components/styledComponents/select';
import {t} from "../../../../helpers/translator";
import PropTypes from 'prop-types';
import Config from "../../../../../dev/config/main";
import { changeOddsFormat } from '../../../../actions/ui';

class OddsSelector extends Component {
    constructor (props) {
        super(props);
        this.changeHandler = this.changeHandler.bind(this);
    }
    changeHandler (name, value) {
        this.props.dispatch(changeOddsFormat(value));
    }
    render () {
        return (
            <React.Fragment>
                <Select
                    data={Config.availableOdds.filter(item => item.enabled).map((item) => ({ value: item.odds, text: t(item.title) }))}
                    value={this.props.oddsFormat}
                    name={'ss'}
                    onChange={this.changeHandler}
                    width={'130px'}
                />
            </React.Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        oddsFormat: state.uiState.oddsFormat
    };
};

OddsSelector.propTypes = {
    oddsFormat: PropTypes.string
};

export default connect(mapStateToProps)(UIMixin({Component: OddsSelector}));